<template>
  <footer
    class="bg-[#293146] dark:bg-gray-900 border-t border-[#3b4660] dark:border-gray-700 mt-auto"
  >
    <div class="max-w-screen-xl mx-auto px-4 pt-16 pb-8">
      <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-8 md:gap-12 mb-12">
        <!-- Brand & Description -->
        <div class="col-span-1 lg:col-span-1">
          <a href="#" class="flex items-center space-x-2 mb-6">
            <span
              class="self-center text-2xl font-bold whitespace-nowrap text-white dark:text-white tracking-tight"
              >lokerjambi<span class="text-[#C5B47A] dark:text-[#C5B47A]">.co.id</span></span
            >
          </a>
          <p class="text-gray-400 dark:text-gray-300 text-sm leading-relaxed mb-6">
            {{ $t('footer.description') }}
          </p>
          <div class="flex space-x-4">
            <!-- Social Icons -->
            <a
              href="#"
              class="text-gray-400 dark:text-gray-400 hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
            >
              <span class="sr-only">Facebook</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12c0 4.991 3.657 9.128 8.438 9.878v-6.987h-2.54V12h2.54V9.797c0-2.506 1.492-3.89 3.777-3.89 1.094 0 2.238.195 2.238.195v2.46h-1.26c-1.243 0-1.63.771-1.63 1.562V12h2.773l-.443 2.89h-2.33v6.988C18.343 21.128 22 16.991 22 12z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 dark:text-gray-400 hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
            >
              <span class="sr-only">Instagram</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M12.315 2c2.43 0 2.784.013 3.808.06 1.064.049 1.791.218 2.427.465a4.902 4.902 0 011.772 1.153 4.902 4.902 0 011.153 1.772c.247.636.416 1.363.465 2.427.048 1.067.06 1.407.06 4.123v.08c0 2.643-.012 2.987-.06 4.043-.049 1.064-.218 1.791-.465 2.427a4.902 4.902 0 01-1.153 1.772 4.902 4.902 0 01-1.772 1.153c-.636.247-1.363.416-2.427.465-1.067.048-1.407.06-4.123.06h-.08c-2.643 0-2.987-.012-4.043-.06-1.064-.049-1.791-.218-2.427-.465a4.902 4.902 0 01-1.772-1.153 4.902 4.902 0 01-1.153-1.772c-.247-.636-.416-1.363-.465-2.427-.047-1.024-.06-1.379-.06-3.808v-.63c0-2.43.013-2.784.06-3.808.049-1.064.218-1.791.465-2.427a4.902 4.902 0 011.153-1.772A4.902 4.902 0 015.45 2.525c.636-.247 1.363-.416 2.427-.465C8.901 2.013 9.256 2 11.685 2h.63zm-.081 1.802h-.468c-2.456 0-2.784.011-3.807.058-.975.045-1.504.207-1.857.344-.467.182-.8.398-1.15.748-.35.35-.566.683-.748 1.15-.137.353-.3.882-.344 1.857-.047 1.023-.058 1.351-.058 3.807v.468c0 2.456.011 2.784.058 3.807.045.975.207 1.504.344 1.857.182.466.399.8.748 1.15.35.35.683.566 1.15.748.353.137.882.3 1.857.344 1.054.048 1.37.058 4.041.058h.08c2.597 0 2.917-.01 3.96-.058.976-.045 1.505-.207 1.858-.344.466-.182.8-.398 1.15-.748.35-.35.566-.683.748-1.15.137-.353.3-.882.344-1.857.048-1.055.058-1.37.058-4.041v-.08c0-2.597-.01-2.917-.058-3.96-.045-.976-.207-1.505-.344-1.858a3.097 3.097 0 00-.748-1.15 3.098 3.098 0 00-1.15-.748c-.353-.137-.882-.3-1.857-.344-1.023-.047-1.351-.058-3.807-.058zM12 6.865a5.135 5.135 0 110 10.27 5.135 5.135 0 010-10.27zm0 1.802a3.333 3.333 0 100 6.666 3.333 3.333 0 000-6.666zm5.338-3.205a1.2 1.2 0 110 2.4 1.2 1.2 0 010-2.4z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 dark:text-gray-400 hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
            >
              <span class="sr-only">Twitter</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  d="M8.29 20.251c7.547 0 11.675-6.253 11.675-11.675 0-.178 0-.355-.012-.53A8.348 8.348 0 0022 5.92a8.19 8.19 0 01-2.357.646 4.118 4.118 0 001.804-2.27 8.224 8.224 0 01-2.605.996 4.107 4.107 0 00-6.993 3.743 11.65 11.65 0 01-8.457-4.287 4.106 4.106 0 001.27 5.477A4.072 4.072 0 012.8 9.713v.052a4.105 4.105 0 003.292 4.022 4.095 4.095 0 01-1.853.07 4.108 4.108 0 003.834 2.85A8.233 8.233 0 012 18.407a11.616 11.616 0 006.29 1.84"
                />
              </svg>
            </a>
            <a
              href="#"
              class="text-gray-400 dark:text-gray-400 hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
            >
              <span class="sr-only">LinkedIn</span>
              <svg class="w-5 h-5" fill="currentColor" viewBox="0 0 24 24" aria-hidden="true">
                <path
                  fill-rule="evenodd"
                  d="M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z"
                  clip-rule="evenodd"
                />
              </svg>
            </a>
          </div>
        </div>

        <!-- Pencari Kerja -->
        <div>
          <h3
            class="mb-4 text-sm font-semibold text-white dark:text-white uppercase tracking-wider"
          >
            {{ $t('footer.jobSeeker') }}
          </h3>
          <ul class="text-gray-400 dark:text-gray-300 space-y-3 font-medium text-sm">
            <li>
              <a
                href="#"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.jobs') }}</a
              >
            </li>
            <li>
              <router-link
                to="/cv"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.createCv') }}</router-link
              >
            </li>
            <li>
              <a
                href="https://blog.lokerjambi.co.id"
                target="_blank"
                rel="noopener"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Tips Karir &amp; Artikel</a
              >
            </li>
            <li>
              <router-link
                to="/bookmarks"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.savedJobs') }}</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Perusahaan -->
        <div>
          <h3
            class="mb-4 text-sm font-semibold text-white dark:text-white uppercase tracking-wider"
          >
            {{ $t('footer.company') }}
          </h3>
          <ul class="text-gray-400 dark:text-gray-300 space-y-3 font-medium text-sm">
            <li>
              <router-link
                to="/post-job"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.postJob') }}</router-link
              >
            </li>
            <li>
              <a
                href="#"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.findCandidates') }}</a
              >
            </li>
            <li>
              <router-link
                to="/post-job"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.pricing') }}</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Tentang Kami -->
        <div>
          <h3
            class="mb-4 text-sm font-semibold text-white dark:text-white uppercase tracking-wider"
          >
            {{ $t('footer.aboutUs') }}
          </h3>
          <ul class="text-gray-400 dark:text-gray-300 space-y-3 font-medium text-sm">
            <li>
              <router-link
                to="/about"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.about') }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/contact"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.contactUs') }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/terms"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.terms') }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/faq"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.faq') }}</router-link
              >
            </li>
            <li>
              <router-link
                to="/privacy-policy"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >{{ $t('footer.privacy') }}</router-link
              >
            </li>
          </ul>
        </div>

        <!-- Area Populer -->
        <div>
          <h3
            class="mb-4 text-sm font-semibold text-white dark:text-white uppercase tracking-wider"
          >
            Area Populer
          </h3>
          <ul class="text-gray-400 dark:text-gray-300 space-y-3 font-medium text-sm">
            <li>
              <router-link
                to="/lokasi/jambi"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Kota Jambi</router-link
              >
            </li>
            <li>
              <router-link
                to="/lokasi/muaro-jambi"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Muaro Jambi</router-link
              >
            </li>
            <li>
              <router-link
                to="/lokasi/bungo"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Bungo</router-link
              >
            </li>
            <li>
              <router-link
                to="/lokasi/jakarta"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Jakarta</router-link
              >
            </li>
            <li>
              <router-link
                to="/lokasi/palembang"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Palembang</router-link
              >
            </li>
            <li>
              <router-link
                to="/lokasi/pekanbaru"
                class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
                >Pekanbaru</router-link
              >
            </li>
          </ul>
        </div>
      </div>

      <!-- Bottom Bar -->
      <div
        class="pt-8 border-t border-[#3b4660] dark:border-gray-700 flex flex-col md:flex-row items-center justify-between"
      >
        <div class="flex flex-col items-center md:items-start mt-4 md:mt-0 order-2 md:order-1">
          <span class="text-sm text-gray-400 dark:text-gray-400 text-center md:text-left">
            © {{ currentYear }}
            <a href="#" class="hover:text-[#C5B47A] dark:hover:text-[#C5B47A] transition-colors"
              >lokerjambi.co.id</a
            >
            | PT Uwais Digital Hired
          </span>
          <span class="text-[8px] text-gray-500 dark:text-gray-500 mt-1 font-mono tracking-wider text-center md:text-left opacity-50">
            Build: {{ buildVersion }}
          </span>
        </div>
        <div class="flex items-center space-x-4 order-1 md:order-2">
          <a
            href="#"
            class="text-sm text-gray-400 dark:text-gray-400 hover:text-white dark:hover:text-white transition-colors"
            >{{ $t('footer.help') }}</a
          >
          <router-link
            to="/faq"
            class="text-sm text-gray-400 dark:text-gray-400 hover:text-white dark:hover:text-white transition-colors"
            >{{ $t('footer.faq') }}</router-link
          >
        </div>
      </div>
    </div>
  </footer>
</template>

<script setup>
import { computed } from 'vue';

const currentYear = computed(() => new Date().getFullYear());
const buildVersion = typeof __APP_VERSION__ !== 'undefined' ? __APP_VERSION__ : 'v0.0.0-dev';
</script>
